import React from 'react';
import { BUTTON_VARIANTS, BUTTON_SIZES } from '../../utils/constants';

interface ButtonProps {
  variant?: keyof typeof BUTTON_VARIANTS;
  size?: keyof typeof BUTTON_SIZES;
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  title?: string;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'PRIMARY',
  size = 'MEDIUM',
  onClick,
  disabled = false,
  children,
  className = '',
  type = 'button',
  title,
}) => {
  const baseClasses = [
    'button',
    `button--${BUTTON_VARIANTS[variant]}`,
    `button--${BUTTON_SIZES[size]}`,
    disabled && 'button--disabled',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={baseClasses}
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
      {children}
    </button>
  );
};

export default Button;